import { mapMutations } from "vuex"
export default {
    data() {
        return {
            activated: false
        }
    },
    mounted: function() {
        this.activated = true
    },
    activated() {
        this.activated = true
    },
    deactivated() {
        this.activated = false
    },
    methods: {
        ...mapMutations({ setLoadingState: "setLoadingState" })
    },
    beforeDestroy() {
        this.loading = false
    },
    computed: {
        loading: {
            set(value) {
                this.setLoadingState(value)
            },
            get() {
                return this.$store.state.loading
            }
        }
    }
}
